import React from "react"
import classNames from "classnames"
import styles from "./Banner.module.scss"
import ButtonComponent from "../../Button/Button"

const Banner = ({ onReadMoreClick, article = {} }) => (
  <div className={styles.wrapper}>
    {article.image_url ? (
      <div
        className={styles.backdrop}
        style={{ backgroundImage: `url(${article.image_url})` }}
      />
    ) : null}
    <div className={styles.media}>
      {article.image_url ? (
        <img
          src={article.image_url}
          alt={article.title || ""}
          className={styles.fullImage}
          referrerPolicy="no-referrer"
        />
      ) : null}
    </div>
    <div className={styles.overlay} />
    <div className={classNames("container", styles.content)}>
      {article.title ? (
        <div className={styles.title}>
          <p>{article.title}</p>
        </div>
      ) : null}
      <div className={styles.buttonWrapper}>
        <ButtonComponent
          buttonStyle="contained"
          onClick={onReadMoreClick}
          className={styles.readMore}
        >
          Read more
        </ButtonComponent>
      </div>
    </div>
  </div>
)

export default Banner
